import { DomApplier } from '../cssFeatures.types'
import { SelectorObj } from '../../shared.types'

export const rotatedComponentsStyleDomApplier: DomApplier<'rotatedComponentsStyle'> = (
	compId,
	idSelector, // idSelector is the same as `#${compId}` or '#[id^compId__]' if compId is a repeater
	breakpointId,
	{ rotatedComponentsStyleCss }
) => {
	const css: SelectorObj = {}
	for (const prefix in rotatedComponentsStyleCss) {
		const selector = prefix ? `${prefix} ${idSelector}` : idSelector
		css[selector] = { transform: `rotate(${rotatedComponentsStyleCss[prefix]}deg)` }
	}
	return css
}
